<template>
  <div
    class="tw-w-full tw-overflow-hidden tw-rounded-xl tw-border-2 tw-border-secondary-500 tw-bg-gradient-to-b tw-from-white tw-via-white tw-to-secondary-50 tw-shadow-xl"
  >
    <div class="tw-flex tw-items-center tw-justify-between tw-space-x-2 tw-p-4">
      <div class="tw-flex tw-items-center tw-space-x-4">
        <SubscriptionPlanBadge
          class="tw-size-10 tw-drop-shadow-md"
          group="pro"
        />
        <h2 class="tw-heading-1 tw-capitalize">Pro</h2>
      </div>
    </div>
    <hr class="tw-border tw-border-secondary-500" />
    <div class="tw-space-y-2 tw-p-6 tw-font-medium">
      <div
        v-for="perk in perks"
        :key="perk.text"
        class="tw-flex tw-items-center"
      >
        <component :is="perk.icon" class="tw-mr-4 tw-h-4 tw-w-4" />
        {{ perk.text }}
        <InfoTooltip
          v-if="perk.tooltip"
          :title="perk.text"
          :tooltip="perk.tooltip"
          placement="right"
          class="tw-ml-1"
        />
      </div>
    </div>
    <InertiaLink
      class="tw-block tw-w-full tw-bg-secondary-500 tw-py-2 tw-text-center tw-text-white"
      href="/subscription/plans"
    >
      Upgrade to Pro
    </InertiaLink>
  </div>
</template>

<script setup>
import { getPlanPerksWithIcons } from '@/shared/data/planPerks.js'
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import InfoTooltip from '@/shared/components/InfoTooltip.vue'
import SubscriptionPlanBadge from '@/shared/components/SubscriptionPlanBadge.vue'

const page = usePage()

const perks = computed(() => {
  return getPlanPerksWithIcons(page.props.planPerks.pro)
})
</script>
